// extracted by mini-css-extract-plugin
module.exports = {"productPromoBanner":"v1_productPromoBanner__4de7H"};